// extracted by mini-css-extract-plugin
export default {"content":"AddOnsModal_content__nJM1M"};